import { useEffect, useState } from 'react';

export const useScreenSizeGuard = () => {
  const [isTooSmall, setIsTooSmall] = useState(false);

  const checkScreenSize = () => setIsTooSmall(globalThis.innerWidth < 320);

  useEffect(() => {
    checkScreenSize();
    globalThis.addEventListener('resize', checkScreenSize);
    return () => globalThis.removeEventListener('resize', checkScreenSize);
  }, []);

  return isTooSmall;
};
